module.exports = __webpack_public_path__ + "static/nxrt-automotive10-b572b31662d00b49c1655b4e6039b386.jpg";